import palomaBackend from "@astina/paloma-common-ui/src/services/PalomaBackend";
import { handleHttpError } from "@astina/paloma-common-ui/src/services/Alerts";
import env from "../services/AppEnv";
const http = palomaBackend.http;
class ShopExportProfileRepository {
    get(id) {
        return http.get(`orders/shop/export/profiles/${id}`, { params: { locale: env.locale, } })
            .then((response) => {
            return response.data;
        })
            .catch(handleHttpError);
    }
    generateInputPassword(id, disable) {
        const params = {};
        if (disable !== undefined) {
            params.disable = disable;
        }
        return http.post(`orders/shop/export/profiles/${id}/generate-input-password`, { params: params })
            .then((response) => {
            return response.data;
        })
            .catch(handleHttpError);
    }
}
export default new ShopExportProfileRepository();
